import Feature from 'ol/Feature';
import Polygon from 'ol/geom/Polygon';
import { poligonStyleWithPhrase } from '../styles/styles'
import * as _ from 'lodash'
import { checkCoordinateIsValid, getPosition} from "../helpers/helpers";

export class ZoneFeature {
  constructor(
    imageWidthInPixels,
    imageHeightInPixels,
    zone,
    type,
    zoneType,
    map,
    mapProps
  ) {

    if (!imageWidthInPixels || !imageHeightInPixels ||
      !zone || !type) {
      return null
    }

    this.type = type;
    this.zoneType = zoneType;
    this.objectType = 13; // type id in navigine
    this.zone = zone;
    this.map = map;
    this.mapProps = mapProps;

    this.originalCoordinates = zone.points || zone.coordinates;
    this.coordinates = this.originalCoordinates.map((coordinatesObject) => {
      const {kx, ky} = coordinatesObject;
      return getPosition({
        kx, 
        ky, 
        mapProps, 
        extent: 
        this.map.extentMap
      }, this.map.modes.globalMap)
    });
    
    this.openLayersFeature = new Feature({
      type,
      payload: this,
      geometry: new Polygon([this.coordinates]),
    });

    let color = this.zoneType ? this.zoneType.zone_type_color : '#2F4F4F';
    
    this.openLayersFeature.setId(zone.id);
    this.openLayersFeature.setStyle(this.createZoneStyle(zone.title || zone.name, color, true));
    return this.openLayersFeature;
  }

  updateCoord(){
    this.coordinates = this.zone.points.map((coordinatesObject) => {
      const {kx, ky} = coordinatesObject;
      return getPosition({
        kx, 
        ky, 
        mapProps: this.map.mapProps, 
        extent: this.map.extentMap
      }, this.map.modes.globalMap)
    })
    const geometry = this.openLayersFeature.getGeometry();
    geometry.setCoordinates([this.coordinates]);
  }

  setStyles(style) {
    this.openLayersFeature.setStyle(style);
  }

  // create circle with text style
  createZoneStyle(name, color, highlight) {

    return poligonStyleWithPhrase(name, color, highlight);
  }
}
